import disableMainAndFooter from "../helpers/disableMainAndFooter";
import enableMainAndFooter from "../helpers/enableMainAndFooter";
export default function burgerButtonRendering(commonComponents) {
    var burgerButton = document.getElementById("burger-button");
    burgerButton.addEventListener("click", burgerButtonClickEvent);
    function burgerButtonClickEvent() {
        if (commonComponents.asideNavBarContainer.style.display === "flex") {
            enableMainAndFooter(commonComponents);
        }
        else {
            disableMainAndFooter(commonComponents);
        }
    }
}
